import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "notifications";
const notifications = createEndpointBase(base);

export const notificationsEndpoints = {
  notificationsAuthenticate: notifications({
    method: "POST",
    path: "auth",
    request: z.any(),
    response: z.any(),
    responseType: {} as { token: string; userId: string; publicApiKey: string },
    description: "Authenticates the current user for receiving notifications.",
  }),
  notificationsInitialize: notifications({
    method: "POST",
    path: "initialize",
    request: z.any(),
    response: z.any(),
    description: "Initializes the notification service for the current host.",
  }),
  notificationsGetSettings: notifications({
    method: "GET",
    path: "settings",
    request: z.any(),
    response: z.any(),
    responseType: {} as { enabled: boolean },
    description: "Retrieves the current notification service settings.",
  }),
} as const;
